import {
  IUserFunction,
  IUserFunctionsResponse
} from 'types/functions';
import request from './index';

export const getUserFunctions = () => {
  try {
    return request<IUserFunctionsResponse>({
      options: {
        url: `/functions`,
        method: 'get'
      }
    });
  } catch (e) {
    console.error(e);
    return { data: [], error: e };
  }
};

export const getFunction = (id: string) =>
  request<IUserFunction>({
    options: {
      url: `/functions/${id}`,
      method: 'get'
    }
  });

export interface IFunctionPayload {
  function: {
    name: string;
    state?: string;
    area_ids?: number[];
    name_translations?: Record<string, string>;
  };
}

export const createFunction = (payload: IFunctionPayload) =>
  request<IUserFunction>({
    options: {
      url: '/functions',
      method: 'post',
      data: payload
    }
  });

export const updateFunction = (id: string, payload: IFunctionPayload) =>
  request<IUserFunction>({
    options: {
      url: `/functions/${id}`,
      method: 'patch',
      data: payload
    }
  });

export const deleteFunction = (id: string) =>
  request<void>({
    options: {
      url: `/functions/${id}`,
      method: 'delete'
    }
  });
